import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import { Route, Routes } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import Company from "@pages/company/company";
import DirectorySystems from "@pages/directory-systems/directory-systems";
// import { EditRequestTraining } from "@feature/request-training/edit-request-training";
import EditRequestTrainingPage from "@pages/EditRequestTrainingPage/control-request-training-page";
import FeedbackItem from "@pages/feedback/feedback-item";
import Feedbacks from "@pages/feedback/feedback";
import GosKey from "@pages/goskey/goskey";
import Header from "@components/header";
import Home from "@pages/home";
import NewsAndPracticeRoutes from "@pages/news";
import AdditionalRoutes from "@pages/additional";
import Payment from "@pages/payment/payment";
import Permissions from "@pages/permissions/permissions";
import ProcedureControlCompany from "@pages/procedure-control-company/procedure-control-company";
import { ProfilePage } from "@pages/profile";
import QuestionAnswer from "@pages/question-answer";
import SpecialistPlanPage from "@pages/specialist-plan/specialist-plan";
import StudyCenterRoutes from "@pages/study-center";
import UserGuide from "@pages/userGuide";
import UsersRoutes from "@pages/users";
import { useUnit } from "effector-react";
import { MenuPanel } from "@components/menu-panel";

const AuthUserRoutes: React.FC = () => {
  const permissions = useUnit($UserAddPermissions);
  const [menuDisplay, setMenuDisplay] = useState<boolean>(false);

  const resizeHandler = useCallback(() => {
    const clientWidth = document.documentElement.clientWidth;

    if (clientWidth > 1024 && menuDisplay) {
      setMenuDisplay(false);
    }
  }, [menuDisplay]);

  // LISTENER FOR CLOSING MENU PANEL, WHEN CLIENT WITH > 1024 && MENU PANEL IS OPEN
  useEffect(() => {
    window.addEventListener("resize", resizeHandler);

    return () => window.removeEventListener("resize", resizeHandler);
  }, [resizeHandler]);

  return (
    <>
      <Header
        menuDisplay={menuDisplay}
        onBurgerClick={() => setMenuDisplay(!menuDisplay)}
      />
      <div className={`content-wrapper ${menuDisplay ? "with-menu" : ""}`}>
        <MenuPanel onItemClick={() => setMenuDisplay(false)} />
        <Routes>
          <Route path="/" Component={Home} />
          {permissions.hasPermission(ACTIONS.users_allowedToShow) && (
            <Route path="/settings/*" Component={UsersRoutes} />
          )}
          <Route path="/company/*" Component={Company} />
          <Route path="/specialist-plan/*" Component={SpecialistPlanPage} />
          <Route path="/profile" Component={ProfilePage} />
          <Route path="/user-guide" Component={UserGuide} />
          <Route path="/procedure-control-company/*" Component={ProcedureControlCompany} />
          {permissions.hasPermission(ACTIONS.directories_allowedToShow) && (
            <Route path="/directories/*" Component={DirectorySystems} />
          )}
          <Route path="/study-center/*" Component={StudyCenterRoutes} />
          <Route path="/news/*" Component={NewsAndPracticeRoutes} />
          <Route path="/additional/*" Component={AdditionalRoutes} />
          <Route path="/payment/*" Component={Payment} />
          <Route path="/permissions/*" Component={Permissions} />
          {permissions.hasPermission(ACTIONS.specialistHelp_allowedToShow) && (
            <Route path="/question-answer" Component={QuestionAnswer} />
          )}
          <Route path="/goskey" Component={GosKey} />
          <Route path="/control-request-training/:id" Component={EditRequestTrainingPage} />
          <Route path="/feedback" Component={Feedbacks} />
          <Route path="/feedback/:id" Component={FeedbackItem} />
        </Routes>
      </div>
    </>
  );
};

export default AuthUserRoutes;
